import React from 'react';
import { useTranslation } from 'react-i18next';

import { getWindowWidth } from '../../environment/utils';

/**
 * Renders a tooltip wrapper around toolbar content while accepting a forwarded ref.
 *
 * @param {Object} props - Tooltip props.
 * @returns {React$Element<*>}
 */
const Tooltip = React.forwardRef(({ position, content, children, className }, forwardedRef) => {
    const { t } = useTranslation([ 'main', 'languages' ]);


    if (getWindowWidth() >= 500) {
        return (
            <div
                className = 'tooltip-toolbar-btn'
                ref = { forwardedRef } >
                <span
                    className = { `${position} span` }
                    id = { className }>
                    {typeof content === 'string' ? t(content) : content}
                </span>
                <div>
                    {children}
                </div>
            </div>
        );
    }

    return (
        <span
            className = { className }
            ref = { forwardedRef }>
            {children}
        </span>
    );

});

Tooltip.displayName = 'Tooltip';

export default Tooltip;
